import { IContainer } from "../interfaces/container.interface";

export class Container implements IContainer {
    containerpk: string;
    containerId: string;
    containerMAWP: number;
    containerMaxCapacity: number;
    containerMaxWeight: number;
    containerPumpCarrier: number;
    containerTareWeight: number;
    transportcompanyName: string;
    containermodelName: string;
    weightThreshold: number;
    deletionFlag?: boolean | null;

    constructor(container: IContainer) {
        Object.keys(container).map(key => this[key] = container[key]);
    }

    get isActivated(): boolean {
        return this.deletionFlag !== true
    }

    toggleActivation(): void {
        this.deletionFlag = !this.deletionFlag;
    }
}